import * as React from "react";
import { cx } from "../internal/cx.js";

const cakewalkLogoUrl = new URL("../assets/cakewalk-logo.svg", import.meta.url).href;

export type LogoTone = "orange" | "ink" | "white" | "current";
/**
 * Preset sizes. `mark` renders the icon-only glyph (the leading mark cropped
 * from the wordmark) as a square — use it where the full wordmark won't fit
 * (compact nav, avatars, favicon-scale chrome).
 */
export type LogoSize = "sm" | "md" | "auth" | "lg" | "mark";

export interface LogoProps extends React.HTMLAttributes<HTMLSpanElement> {
  /** Accessible label for the wordmark. */
  label?: string;
  /** Display color. */
  tone?: LogoTone;
  /** Preset display size. `mark` = icon-only square. */
  size?: LogoSize;
}

export const Logo = React.forwardRef<HTMLSpanElement, LogoProps>(function Logo(
  { className, label = "Cakewalk", size = "md", tone = "orange", style, ...props },
  ref,
) {
  return (
    <span
      ref={ref}
      aria-label={label}
      className={cx("cw-v2-logo", `cw-v2-logo--${size}`, `cw-v2-logo--${tone}`, className)}
      role="img"
      style={
        {
          "--cw-v2-logo-url": `url(${cakewalkLogoUrl})`,
          ...style,
        } as React.CSSProperties
      }
      {...props}
    />
  );
});

Logo.displayName = "Logo";
